/**
 * Utility to check if element is either taking up the whole viewport space, or is completely visible within it.
 *
 * Note: This is only working for emulated scroll container.
 *
 * @returns {boolean}
 */
$.fn.isVisibleInScrollingContainer = function () {
    const elementTop = $(this).offset().top;
    const elementHeight = $(this).outerHeight();
    const elementBottom = elementTop + elementHeight;

    const viewportTop = window.scrollY;
    const viewportHeight = window.innerHeight;
    const viewportBottom = viewportTop + viewportHeight;

    /* Is fully visible in viewport? */
    if (elementTop > viewportTop && elementBottom < viewportBottom) {
        return true;
    }

    let topDiff = 0;
    let bottomDiff = 0;
    let viewportCoverage = 0;

    /* Is elementTop in viewport? */
    if (elementTop > viewportTop && elementTop < viewportBottom) {
        topDiff = elementTop - viewportTop;
    }

    /* Is elementBottom in viewport? */
    if (elementBottom < viewportBottom && elementBottom > viewportTop) {
        bottomDiff = viewportBottom - elementBottom;
    }

    /* Is notification in viewport? */
    if (topDiff > 0 || bottomDiff > 0) {
        viewportCoverage = (viewportHeight - topDiff - bottomDiff) / viewportHeight;
    }

    return viewportCoverage > 2/3;
};
